import { GOOGLE_MAPS_SEARCH_URL } from '../constants';

export const getGoogleMapsSearchURL = (latitude: number, longitude: number, placeId?: string) => {
    const url = new URL(GOOGLE_MAPS_SEARCH_URL);
    const params = new URLSearchParams('api=1');
    params.set('query', `${latitude},${longitude}`);
    if (placeId) {
        params.set('query_place_id', placeId);
    }
    url.search = params.toString();

    return url;
};
